@if (proveedor) {
  <div class="cabecera">
    <span class="titulo">PLANTILLA DE CONDICIONES {{ proveedor.condicion.ultimaEdicion | date:'yyyy' }} - {{ proveedor.razonSocial}} </span>
    <button class="btn-cerrar" (click)="cerrarModal()">
    </button>
  </div>
  
  <div class="cuerpo"
    [class.vista-movil]="esResolucionMovil"
  >
    <div class="borde">
      <div class="contenido" id="documento">
        <div class="marca-agua"
          [style]="{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            background: 'url(' + marcaAguaImg + ')',
            'z-index': '1'
          }">
        </div>
        <div class="header">
          <img src="/assets/img/sello-plantilla.png" alt="Logo Unifersa" />
  
          <div class="etiqueta-titulo-plantilla">
            <span class="titulo">PLANTILLA DE CONDICIONES</span>
            <span class="fecha">{{ hoy | date:'d \'de\' MMMM \'de\' y' }}</span>
          </div>
        </div>
  
        <div class="apartado">
          <div class="proveedor">
            <div class="encabezado-proveedor">
              <div class="contenedor-logo">
                <img 
                  class="logo-proveedor" 
                  [src]="urlLogo + proveedor.idFichero" 
                  alt="assets/img/no-disponible.png" 
                  onerror="this.onerror=null; this.src=this.alt;"
                />
              </div>
              <div class="nombres">
                <span class="nombre-proveedor">{{ proveedor.razonSocial }}</span>
              </div>
            </div>
  
            <div class="info-proveedor">
              <div class="fila">
                <div class="campo" id="campo-domicilio">
                  <span class="etiqueta">Dirección</span>
                  <span class="valor">{{ proveedor?.domicilioComercial }}</span>
                </div>
                
                <div class="separador"></div>

                <div class="campo" id="campo-cp">
                  <span class="etiqueta">Código postal</span>
                  <span class="valor">{{ proveedor?.cp }}</span>
                </div>

                <div class="separador"></div>
  
                <div class="campo" id="campo-poblacion">
                  <span class="etiqueta">Población</span>
                  <span class="valor">{{ proveedor?.localidad }}</span>
                </div>
  
                <div class="separador"></div>
  
                <div class="campo" id="campo-provincia">
                  <span class="etiqueta">Provincia</span>
                  <span class="valor">{{ proveedor?.provincia?.nombre }}</span>
                </div>
              </div>
  
              <div class="fila">
                <div class="campo" id="campo-nif">
                  <span class="etiqueta">NIF</span>
                  <span class="valor">{{ proveedor.nif }}</span>
                </div>
  
                <div class="separador"></div>
  
                <div class="campo" id="campo-telefono">
                  <span class="etiqueta">Teléfono</span>
                  <span class="valor">{{ proveedor?.telefono ?? '' }}</span>
                </div>
  
                <div class="separador"></div>
  
                <div class="campo" id="campo-correo">
                  <span class="etiqueta">Correo electrónico</span>
                  <span class="valor">{{ proveedor?.correo }}</span>
                </div>
  
                <div class="separador"></div>
  
                <div class="campo" id="campo-web">
                  <span class="etiqueta">Página web</span>
                  <span class="valor">{{ proveedor?.paginaWeb }}</span>
                </div>
              </div>
            </div>
          </div>
  
          <div class="condiciones">
            <span class="titulo-apartado">
              CONDICIONES DE COMPRA DIRECTA
            </span>
  
            <div class="fila">
              <div class="seccion formas-pago">
                <span class="titulo-seccion">FORMA DE PAGO</span>
    
                <div class="campo">
                  <span>{{ proveedor.condicion.formasPago }}</span>
                </div>
              </div>

              <div class="seccion altas">
                <span class="titulo-seccion">NUEVAS IMPLANTACIONES</span>
    
                <div class="campo">
                  <span>{{ proveedor.condicion.altaTexto }}</span>
                </div>
              </div>
            </div>

            <div class="fila descuentos-portes">
              <div class="seccion descuentos grid">
                <span class="titulo-seccion">DESCUENTOS</span>

                <dx-data-grid
                  [dataSource]="proveedor.condicion.descuentos"
                  [showRowLines]="false"
                  [noDataText]="null"
                  [wordWrapEnabled]="true"
                  [paging]="{ enabled: false }"
                >
                  <dxi-column
                    caption="Concepto"
                    dataField="concepto"
                  >
                  </dxi-column>

                  <dxi-column
                    caption="Grupo"
                    dataField="grupoDto"
                    width="125"
                  >
                  </dxi-column>

                  <dxi-column
                    caption="Descuento"
                    dataField="dto"
                    alignment="right"
                    width="110"
                  >
                  </dxi-column>
                </dx-data-grid>
              </div>

              <div class="seccion portes grid">
                <span class="titulo-seccion">PORTES</span>

                <dx-data-grid
                  [dataSource]="proveedor.condicion.portes"
                  [showRowLines]="false"
                  [noDataText]="null"
                  [paging]="{ enabled: false }"
                >
                  <dxi-column
                    caption="Zona"
                    dataField="zona"
                  >
                  </dxi-column>

                  <dxi-column
                      caption="Pedido sin portes"
                      dataField="importeConCargo"
                      alignment="right"
                  >
                  </dxi-column>

                  <dxi-column
                    caption="Portes"
                    dataField="importe"
                    width="75"
                    alignment="right"
                  >
                  </dxi-column>

                  <dxi-column
                    caption="Pedido mínimo"
                    dataField="pedidoMinimo"
                    width="115"
                    alignment="right"
                  >
                  </dxi-column>
                </dx-data-grid>

                <!-- <div class="seccion observaciones-portes"> -->
                  <!-- <span class="titulo-seccion">OBSERVACIONES PORTES</span> -->
                @if (proveedor.condicion.observacionesPortes) {
                  <div class="observaciones-portes campo">
                    <span class="etiqueta">Observaciones</span>
                    <span class="valor">{{ proveedor.condicion.observacionesPortes }}</span>
                  </div>
                }
                <!-- </div> -->
              </div>
            </div>
          </div>
        </div>
  
        <div class="apartado">
          <div class="representantes">
            <span class="titulo-apartado">CONTACTOS COMERCIALES</span>
  
            <div class="seccion grid">
              <dx-data-grid
                [dataSource]="proveedor.contactos"
                [showRowLines]="false"
                [noDataText]="null"
                [paging]="{ enabled: false }"
              >
                <dxi-column
                  caption="Zona"
                  dataField="provincias"
                  [calculateCellValue]="calculateProvincias"
                  width="400px"
                  cssClass="multilinea"
                >
                </dxi-column>

                <dxi-column
                  caption="Nombre"
                  dataField="nombre"
                  [cssClass]="'bold'"
                  cssClass="multilinea"
                >
                </dxi-column>

                <dxi-column
                  caption="Teléfono"
                  dataField="telefono"
                  width="110px"
                >
                </dxi-column>
  
                <dxi-column
                  caption="Correo Electrónico"
                  dataField="correo"
                  width="290px"
                >
                </dxi-column>
              </dx-data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  @if (puedeDescargarCondiciones((autentificacionService.currentUser | async)?.rol)) {
    <div class="footer">
      <button 
        class="btn-descargar"
        (click)="descargarCondiciones()"
      >
        Descargar Plantilla de Condiciones
      </button>
    </div>
  }
  @else if (puedeDescargarAnexos((autentificacionService.currentUser | async)?.rol) && proveedor?.anexoNombre) {
    <div class="footer">
      <button 
        class="btn-descargar"
        (click)="descargarAnexos()"
      >
        Descargar Anexos de las Condiciones
      </button>
    </div>
  }
}

<dx-load-panel
  #loadPanel
  [(visible)]="panelCargaVisible"
  shadingColor="rgba(0, 0, 0, 0.1)"
  [showIndicator]="true"
  [showPane]="false"
  [shading]="true"
  [hideOnOutsideClick]="false"
>
</dx-load-panel>